var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ClientManagement50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M8 15L6 15 6 6 15 6 15 8 8 8zM42 15L40 15 40 8 33 8 33 6 42 6zM15 42L6 42 6 33 8 33 8 40 15 40zM42 42L33 42 33 40 40 40 40 33 42 33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M28,29c0,0,0,4-4,4s-4-4-4-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7986cb",
    d: "M24,38c4.482,0,8.061-0.018,12,0c-0.619-7.566-8.25-9-8.25-9L24,29.77L20.25,29c0,0-7.632,1.406-8.25,9C15.94,37.982,19.518,38,24,38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6bc0",
    d: "M24,35c3.059,0,5.578-2.292,5.948-5.25c-0.884-0.398-1.603-0.607-1.954-0.693C27.963,31.238,26.189,33,24,33c-2.19,0-3.964-1.762-3.994-3.945c-0.353,0.086-1.071,0.293-1.955,0.688C18.417,32.705,20.938,35,24,35z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef8d3c",
    d: "M32,20.5c0,0.828-0.672,1.5-1.5,1.5c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5C31.328,19,32,19.672,32,20.5 M19,20.5c0-0.828-0.672-1.5-1.5-1.5S16,19.672,16,20.5s0.672,1.5,1.5,1.5S19,21.328,19,20.5 M28,29v-4h-8v4c0,0,0,4,4,4S28,29,28,29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa45",
    d: "M31,16.68c0-5.879-14-3.827-14,0v4.391c0,3.824,3.133,6.93,7,6.93c3.866,0,7-3.105,7-6.93V16.68z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M24,9c-4.86,0-8,4.313-8,8.172V19l2,2v-4l9.2-3l2.8,3v4l2-2v-0.809c0-3.218-0.831-6.803-4.8-7.592L26.399,9H24z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M26,20c0-0.551,0.448-1,1-1s1,0.449,1,1s-0.448,1-1,1S26,20.551,26,20 M20,20c0,0.551,0.448,1,1,1s1-0.449,1-1s-0.448-1-1-1S20,19.449,20,20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ClientManagement50);
export default __webpack_public_path__ + "static/media/icons8-client-management-50.6708abb64960853dbc4dfe3cbeebdfb3.svg";
export { ForwardRef as ReactComponent };